import { TOTAL_SHOTS } from './constants';
import { ChallengeStats, RunGrade, RunSummary } from './types';

export const getRunScore = (stats: ChallengeStats) =>
  stats.goals * 100 + stats.perfectGoals * 50 + stats.bestStreak * 25;

export const getRunGrade = (score: number): RunGrade => {
  if (score >= 750) return 'S';
  if (score >= 600) return 'A';
  if (score >= 400) return 'B';
  if (score >= 200) return 'C';
  return 'Keep going';
};

export const getRunSummary = (stats: ChallengeStats): RunSummary => {
  const score = getRunScore(stats);
  return {
    score,
    grade: getRunGrade(score),
    goals: stats.goals,
    perfectGoals: stats.perfectGoals,
    bestStreak: stats.bestStreak,
  };
};

export const getCurrentShotNumber = (stats: ChallengeStats) =>
  Math.min(TOTAL_SHOTS, stats.attempts + 1);
